import PublicLayout from "@/components/public-layout";

export default function Terms() {
  return (
    <PublicLayout>
      <div className="flex flex-col mt-4 text-center gap-4">
        <h1 className="text-2xl font-bold">Regulamin</h1>
        <iframe
          className="w-[80vw] h-[80vh]"
          src="/RegulaminP4D.pdf"
          allow="same-origin"
        />
      </div>
    </PublicLayout>
  );
}
